import { ChangeDetectorRef, DestroyRef, inject, Injector } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UiHeaderComponent } from '@common/ui/frontend-shared/shared';
import { UiTableComponent } from '@common/ui/frontend-shared/table';
import { LocalMessageHandlerService, ModelActionMenuService, ModelActionService, ModelColumnService, pathFromActivatedRoute, takeWhileAlive } from '@core/frontend-shared';
import { ModelFactoryProvider } from '@core/shared/model';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { ResetPaginationEvent } from '../controller';
import { CrudManagerService } from '../crud-manager';
import { NgClass, NgStyle, AsyncPipe } from '@angular/common';
import { DynamicFieldsetModule } from '@common/forms/frontend-shared';
import { UiButtonComponent } from '@common/ui/frontend-shared/button';
import { UiIconComponent } from '@common/ui/frontend-shared/icons';
import { UiInputGroupComponent } from '@common/ui/frontend-shared/input-group';
import { UiLoadingIndicatorComponent } from '@common/ui/frontend-shared/loading-indicator';
import { UiMenuComponent } from '@common/ui/frontend-shared/menu';
import { UiToolbarComponent } from '@common/ui/frontend-shared/toolbar';
import { CustomAttributesDirective, NgLetDirective } from '@core/frontend-shared/utils/directives';
import { CrudTableItemComponent } from './crud-table-item.component';
import * as i0 from "@angular/core";
import * as i1 from "../crud-manager";
import * as i2 from "@core/shared/model";
import * as i3 from "@angular/router";
import * as i4 from "@core/frontend-shared";
import * as i5 from "../../../../../forms/frontend-shared/src/lib/filter-fieldset/filter-fieldset.component";
import * as i6 from "@common/ui/frontend-shared/card";
import * as i7 from "@common/ui/frontend-shared/table";
const _c0 = ["dataTable"];
const _c1 = [[["ui-header"]]];
const _c2 = ["ui-header"];
const _c3 = a0 => ({
  "ui-button-contrast": a0
});
const _c4 = () => [];
const _c5 = () => ["selection"];
const _c6 = (a0, a1) => ({
  width: a0,
  textAlign: a1
});
const _c7 = a0 => ({
  "enabled": a0
});
function CrudTableComponent_Conditional_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 13);
    i0.ɵɵlistener("click", function CrudTableComponent_Conditional_3_Conditional_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.crudManager.navigate(["new"]));
    });
    i0.ɵɵelementEnd();
  }
}
function CrudTableComponent_Conditional_3_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 14);
    i0.ɵɵlistener("click", function CrudTableComponent_Conditional_3_Conditional_2_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.crudManager.navigate(["batch"]));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("label", !ctx_r2.crudManager.enableCreate ? "Neu" : "Stapelverarbeitung")("ngClass", i0.ɵɵpureFunction1(2, _c3, ctx_r2.crudManager.enableCreate));
  }
}
function CrudTableComponent_Conditional_3_For_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 15);
    i0.ɵɵlistener("click", function CrudTableComponent_Conditional_3_For_4_Template_button_click_0_listener($event) {
      const btn_r6 = i0.ɵɵrestoreView(_r5).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onCustomButtonClick($event, btn_r6));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const btn_r6 = ctx.$implicit;
    i0.ɵɵclassMap(btn_r6.class);
    i0.ɵɵproperty("label", btn_r6.label)("icon", btn_r6.icon)("customAttributes", btn_r6.attributes);
  }
}
function CrudTableComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ui-input-group", 3);
    i0.ɵɵconditionalCreate(1, CrudTableComponent_Conditional_3_Conditional_1_Template, 1, 0, "button", 9);
    i0.ɵɵconditionalCreate(2, CrudTableComponent_Conditional_3_Conditional_2_Template, 1, 4, "button", 10);
    i0.ɵɵrepeaterCreate(3, CrudTableComponent_Conditional_3_For_4_Template, 1, 5, "button", 11, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementStart(5, "button", 12);
    i0.ɵɵlistener("click", function CrudTableComponent_Conditional_3_Template_button_click_5_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.refresh());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("rounded", true);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.crudManager.enableCreate ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.config.batch ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r2.config.list.toolbarButtons);
  }
}
function CrudTableComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4)(1, "filter-fieldset", 16);
    i0.ɵɵlistener("valueChanged", function CrudTableComponent_Conditional_4_Template_filter_fieldset_valueChanged_1_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.updateFilters($event));
    })("formService", function CrudTableComponent_Conditional_4_Template_filter_fieldset_formService_1_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.listController.bindFilterFieldsetFormService($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("instructions", ctx_r2.config.list.filters)("inputGroupBreakpoint", 800);
  }
}
function CrudTableComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p", 5)(1, "span");
    i0.ɵɵtext(2, "Suchergebnisse");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "button", 17);
    i0.ɵɵlistener("click", function CrudTableComponent_Conditional_6_Template_button_click_3_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onClickResetSearch());
    });
    i0.ɵɵelementEnd()();
  }
}
function CrudTableComponent_Conditional_8_ng_template_0_ng_template_4_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 22);
    i0.ɵɵelement(1, "ui-icon", 24);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("pSortableColumn", "ordering");
  }
}
function CrudTableComponent_Conditional_8_ng_template_0_ng_template_4_For_3_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "p-sortIcon", 25);
  }
  if (rf & 2) {
    const col_r10 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("field", col_r10.field);
  }
}
function CrudTableComponent_Conditional_8_ng_template_0_ng_template_4_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 23);
    i0.ɵɵtext(1);
    i0.ɵɵconditionalCreate(2, CrudTableComponent_Conditional_8_ng_template_0_ng_template_4_For_3_Conditional_2_Template, 1, 1, "p-sortIcon", 25);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const col_r10 = ctx.$implicit;
    i0.ɵɵproperty("pSortableColumn", col_r10.field)("pSortableColumnDisabled", !col_r10._isSortable)("ngStyle", i0.ɵɵpureFunction2(5, _c6, col_r10.width, col_r10.align || "left"));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", col_r10.header, " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional(col_r10._isSortable ? 2 : -1);
  }
}
function CrudTableComponent_Conditional_8_ng_template_0_ng_template_4_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "th");
  }
}
function CrudTableComponent_Conditional_8_ng_template_0_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵconditionalCreate(1, CrudTableComponent_Conditional_8_ng_template_0_ng_template_4_Conditional_1_Template, 2, 1, "th", 22);
    i0.ɵɵrepeaterCreate(2, CrudTableComponent_Conditional_8_ng_template_0_ng_template_4_For_3_Template, 3, 8, "th", 23, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵconditionalCreate(4, CrudTableComponent_Conditional_8_ng_template_0_ng_template_4_Conditional_4_Template, 1, 0, "th");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const columns_r11 = ctx.$implicit;
    const tableState_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵconditional(tableState_r12.reorderingEnabled ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(columns_r11);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(tableState_r12.showButtonCol ? 4 : -1);
  }
}
function CrudTableComponent_Conditional_8_ng_template_0_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tr", 26);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "async");
  }
  if (rf & 2) {
    const rowData_r13 = ctx.$implicit;
    const index_r14 = ctx.rowIndex;
    const loadingState_r15 = i0.ɵɵnextContext().$implicit;
    const tableState_r12 = i0.ɵɵnextContext();
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(18, _c7, rowData_r13.enabled))("pReorderableRow", tableState_r12.reorderingPermitted ? index_r14 : null)("uiSelectableRow", rowData_r13)("uiSelectableRowDisabled", !ctx_r2.crudManager.enableEdit)("item", rowData_r13)("tableState", tableState_r12)("loadingState", loadingState_r15)("enableContextMenu", i0.ɵɵpipeBind1(1, 12, ctx_r2.enableContextMenu$))("uiContextMenuRow", rowData_r13)("uiContextMenuRowDisabled", !i0.ɵɵpipeBind1(2, 14, ctx_r2.enableContextMenu$))("dependencies", ctx_r2.listController.dependencies)("loadingDependencies", i0.ɵɵpipeBind1(3, 16, ctx_r2.isLoadingDependencies$));
  }
}
function CrudTableComponent_Conditional_8_ng_template_0_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "td", 27);
    i0.ɵɵelement(2, "ui-icon", 28);
    i0.ɵɵtext(3, " Keine Eintr\u00E4ge gefunden. ");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵattribute("colspan", ctx_r2.getTotalColumns());
  }
}
function CrudTableComponent_Conditional_8_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ui-table", 18, 1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "async");
    i0.ɵɵlistener("onLazyLoad", function CrudTableComponent_Conditional_8_ng_template_0_Template_ui_table_onLazyLoad_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.reloadItems($event));
    })("onRowSelect", function CrudTableComponent_Conditional_8_ng_template_0_Template_ui_table_onRowSelect_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.updateSelection($event));
    })("onRowReorder", function CrudTableComponent_Conditional_8_ng_template_0_Template_ui_table_onRowReorder_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.persistTableItemOrdering($event));
    })("contextMenuSelectionChange", function CrudTableComponent_Conditional_8_ng_template_0_Template_ui_table_contextMenuSelectionChange_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.contextMenuItemsService.setContextMenuSelection($event));
    });
    i0.ɵɵtemplate(4, CrudTableComponent_Conditional_8_ng_template_0_ng_template_4_Template, 5, 2, "ng-template", 19)(5, CrudTableComponent_Conditional_8_ng_template_0_ng_template_5_Template, 4, 20, "ng-template", 20)(6, CrudTableComponent_Conditional_8_ng_template_0_ng_template_6_Template, 4, 1, "ng-template", 21);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_9_0;
    const loadingState_r15 = ctx.$implicit;
    const tableState_r12 = i0.ɵɵnextContext();
    const ctx_r2 = i0.ɵɵnextContext();
    const contextMenuRef_r16 = i0.ɵɵreference(12);
    i0.ɵɵproperty("columns", tableState_r12.columns)("value", i0.ɵɵpipeBind1(2, 18, ctx_r2.items$))("lazy", true)("totalRecords", (tmp_9_0 = i0.ɵɵpipeBind1(3, 20, ctx_r2.rangeInfo$)) == null ? null : tmp_9_0.total)("selectionMode", ctx_r2.crudManager.enableEdit ? "single" : null)("globalFilterFields", i0.ɵɵpureFunction0(22, _c4))("loading", loadingState_r15.allLoading)("paginator", ctx_r2.config.list.itemsPerPage !== false)("rows", ctx_r2.config.list.itemsPerPage || -1)("rowsPerPageOptions", ctx_r2.config.list.itemsPerPageOptions)("stateKey", ctx_r2.getUniqueControllerId())("stateExcludedProps", i0.ɵɵpureFunction0(23, _c5))("sortField", ctx_r2.listController.getDefaultSortField())("sortOrder", ctx_r2.listController.getDefaultSortOrdering())("rowTrackBy", ctx_r2.config.list.trackBy)("showCurrentPageReport", true)("paginatorDropdownAppendTo", "body")("contextMenu", contextMenuRef_r16);
  }
}
function CrudTableComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, CrudTableComponent_Conditional_8_ng_template_0_Template, 7, 24, "ng-template", 6);
    i0.ɵɵpipe(1, "async");
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngLet", i0.ɵɵpipeBind1(1, 1, ctx_r2.loadingState$));
  }
}
function CrudTableComponent_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ui-loading-indicator", 7);
  }
  if (rf & 2) {
    i0.ɵɵproperty("loading", true);
  }
}
;
export let CrudTableComponent = /*#__PURE__*/(() => {
  class CrudTableComponent {
    get config() {
      return this.crudManager.config;
    }
    get service() {
      return this.crudManager.service;
    }
    get filterFormService() {
      return this.listController.getFilterFormService();
    }
    constructor(crudManager, modelFactoryProvider, route, router, cd, modelColumnService) {
      this.crudManager = crudManager;
      this.modelFactoryProvider = modelFactoryProvider;
      this.route = route;
      this.router = router;
      this.cd = cd;
      this.modelColumnService = modelColumnService;
      this.destroyRef = inject(DestroyRef);
      this.actionsService = inject(ModelActionService);
      this.contextMenuItemsService = new ModelActionMenuService();
      this.items$ = new BehaviorSubject(null);
      // ui-table will call this method whenever paging or ordering changes.
      this.reloadItems = event => {
        const ordering = event.sortField ? {
          field: event.sortField,
          order: event.sortOrder
        } : {
          field: null,
          order: 0
        };
        this.listController.updateListState({
          paging: {
            offset: event.first,
            itemsPerPage: event.rows
          },
          ordering: [ordering]
        });
      };
      // -------------  FILTERING + ORDERING  -----------------------------------------------------------------
      this.updateFilters = data => {
        const anyFilterSet = Object.values(data).some(value => value !== null && typeof value !== "undefined");
        const debounceMs = anyFilterSet ? 300 : 30;
        this.listController.updateListState({
          filters: data
        }, debounceMs);
        this.cd.markForCheck();
      };
      this.listController = crudManager.getListController();
      this.listController.persistState(this.getUniqueControllerId());
      const obs = this.listController.getSubscriptions();
      this.loadingState$ = obs.loadingState$.pipe(takeWhileAlive(this.destroyRef));
      this.isLoadingDependencies$ = obs.isLoadingDependencies$.pipe(takeWhileAlive(this.destroyRef));
      this.currentOrdering$ = obs.currentOrdering$.pipe(takeWhileAlive(this.destroyRef));
      this.reorderingPermitted$ = obs.reorderingPermitted$.pipe(takeWhileAlive(this.destroyRef));
      this.hasActiveFilters$ = obs.hasActiveFilters$.pipe(takeWhileAlive(this.destroyRef));
      this.itemColumns$ = obs.itemColumns$.pipe(takeWhileAlive(this.destroyRef));
      this.rangeInfo$ = obs.rangeInfo$.pipe(takeWhileAlive(this.destroyRef));
      obs.listStateEvents$.pipe(takeWhileAlive(this.destroyRef)).subscribe(event => {
        if (event instanceof ResetPaginationEvent) {
          // TODO: in case of not-yet-available dataTable, it may be required to delay this action until it is available?
          if (this.dataTable) this.dataTable.first = event.offset;
        }
      });
      this.listController.createItemsObservable().pipe(takeWhileAlive(this.destroyRef)).subscribe(items => {
        this.items$.next(items);
      });
      this.contextMenuItemsService.setItemModelActions$(this.crudManager.getItemActions$('list'));
      const {
        contextMenuActionsForItem$,
        enableContextMenu$
      } = this.contextMenuItemsService.getSubscriptions(this.actionsService, inject(Injector));
      this.enableContextMenu$ = enableContextMenu$.pipe(takeWhileAlive(this.destroyRef));
      this.contextMenuActionsForItem$ = contextMenuActionsForItem$.pipe(takeWhileAlive(this.destroyRef));
      this.initializeObservables();
    }
    initializeObservables() {
      this.tableState$ = combineLatest({
        loadingState: this.loadingState$,
        columns: this.itemColumns$,
        itemActions: this.crudManager.getItemActions$('list'),
        reorderingPermitted: this.reorderingPermitted$
      }).pipe(map(({
        columns,
        itemActions,
        reorderingPermitted,
        loadingState
      }) => {
        const reorderingEnabled = this.config.list.reordering;
        const showButtonCol = this.crudManager.enableDelete || this.crudManager.enableEdit || itemActions?.length > 0;
        let totalColumnCount = columns.length;
        if (reorderingEnabled) totalColumnCount++;
        if (showButtonCol) totalColumnCount++;
        const info = {
          columns: columns.map(col => {
            return {
              ...col,
              _isSortable: this.isColSortable(col)
            };
          }),
          reorderingPermitted,
          reorderingEnabled,
          totalColumnCount,
          showButtonCol,
          loadingState,
          showEditButton: this.crudManager.enableEdit && !this.config.list.clickRowToEdit,
          showDeleteButton: this.crudManager.enableDelete
        };
        return info;
      }));
    }
    refresh() {
      this.crudManager.service.refreshAllItems();
    }
    ngAfterViewInit() {
      // this.rangeInfo$.subscribe(info=>{
      // 	console.log('rangeInfo update',info)
      // 	this.dataTable.setPage(info?.page || 0)
      // })
    }
    // -------------  SELECTION + DATA LOADING  -----------------------------------------------------------------
    loadItems() {
      console.warn('loadItems() is useless, listController automates that');
    }
    updateSelection(event) {
      if (this.config.list.clickRowToEdit && this.crudManager.enableEdit) {
        if (event.data) {
          const itemId = event.data.id;
          // const path = this.route.snapshot.params.id ? ['./',event.value[0].id] : [event.value[0].id];
          // this.baseRoute.parent??
          this.crudManager.navigate([itemId]);
        } else {
          this.crudManager.navigate(['./']);
        }
        // we use the selection even for routing, so selection should not be saved. Unset it again.
        this.dataTable.selection = [];
        this.dataTable.cd.markForCheck();
      }
    }
    onClickResetSearch() {
      this.listController.updateListState({
        filters: {}
      });
    }
    isColSortable(col) {
      if (col.sortable === false) return false;
      if (col.sortable === true) return true;
      if (col.render) {
        // if all items are available, this can be ordered on client side
        if (this.config.list.loadAllItems) return true;
        // not possible to order by this column.
        return false;
      }
      return true;
    }
    // -------------  STORE ORDER OF ORDERABLE ITEMS  --------------------------------------------------
    persistTableItemOrdering(event) {
      this.items$.pipe(take(1)).subscribe(items => {
        this.service.crud.updateOrdering(items);
      });
    }
    // -------------  UTILS  -----------------------------------------------------------------
    getCol(field) {
      const match = this.config.list.cols.find(col => {
        return col.field === field;
      });
      return match || null;
    }
    // get a ID identifying the list controller instance. useful for persisted state
    getUniqueControllerId() {
      const url = pathFromActivatedRoute(this.route);
      return 'crud-table-controller-' + url;
    }
    getTotalColumns() {
      let totalColumns = this.config.list.cols.length;
      if (this.config.list.reordering) totalColumns++;
      if (this.crudManager.enableDelete || this.crudManager.enableEdit) totalColumns++;
      return totalColumns;
    }
    onCustomButtonClick(event, btn) {
      this.crudManager.executeCustomButtonAction(event, btn);
    }
    static {
      this.ɵfac = function CrudTableComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CrudTableComponent)(i0.ɵɵdirectiveInject(i1.CrudManagerService), i0.ɵɵdirectiveInject(i2.ModelFactoryProvider), i0.ɵɵdirectiveInject(i3.ActivatedRoute), i0.ɵɵdirectiveInject(i3.Router), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i4.ModelColumnService));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: CrudTableComponent,
        selectors: [["crud-item-table"]],
        contentQueries: function CrudTableComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, UiHeaderComponent, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.header = _t.first);
          }
        },
        viewQuery: function CrudTableComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dataTable = _t.first);
          }
        },
        features: [i0.ɵɵProvidersFeature([LocalMessageHandlerService])],
        ngContentSelectors: _c2,
        decls: 14,
        vars: 12,
        consts: [["contextMenuRef", ""], ["dataTable", ""], [1, "ui-toolbar-group-left"], [3, "rounded"], [1, "ui-toolbar-group-right"], [1, "active-filters-notification"], [3, "ngLet"], ["label", "waiting for tableState...", 3, "loading"], ["appendTo", "body", 3, "popup", "model"], ["e2e-crud-table-create-button", "", "uiButton", "", "type", "button", "label", "Neu", "icon", "plus"], ["e2e-crud-table-create-button", "", "uiButton", "", "type", "button", "icon", "plus", 3, "label", "ngClass"], ["type", "button", "uiButton", "", 3, "label", "icon", "class", "customAttributes"], ["type", "button", "uiButton", "", "icon", "sync-alt", 1, "ui-button-grey", 3, "click"], ["e2e-crud-table-create-button", "", "uiButton", "", "type", "button", "label", "Neu", "icon", "plus", 3, "click"], ["e2e-crud-table-create-button", "", "uiButton", "", "type", "button", "icon", "plus", 3, "click", "label", "ngClass"], ["type", "button", "uiButton", "", 3, "click", "label", "icon", "customAttributes"], [3, "valueChanged", "formService", "instructions", "inputGroupBreakpoint"], ["uiButton", "", "title", "Suche beenden", "icon", "times", 1, "small", "ui-button-invisible", 3, "click"], ["stateStorage", "session", 3, "onLazyLoad", "onRowSelect", "onRowReorder", "contextMenuSelectionChange", "columns", "value", "lazy", "totalRecords", "selectionMode", "globalFilterFields", "loading", "paginator", "rows", "rowsPerPageOptions", "stateKey", "stateExcludedProps", "sortField", "sortOrder", "rowTrackBy", "showCurrentPageReport", "paginatorDropdownAppendTo", "contextMenu"], ["uiTemplate", "header"], ["uiTemplate", "body"], ["uiTemplate", "emptymessage"], [2, "width", "40px", 3, "pSortableColumn"], [3, "pSortableColumn", "pSortableColumnDisabled", "ngStyle"], ["icon", "bars"], [3, "field"], ["crud-table-item", "", 3, "ngClass", "pReorderableRow", "uiSelectableRow", "uiSelectableRowDisabled", "item", "tableState", "loadingState", "enableContextMenu", "uiContextMenuRow", "uiContextMenuRowDisabled", "dependencies", "loadingDependencies"], [2, "text-align", "center", "padding", "10px"], ["icon", "exclamation-triangle"]],
        template: function CrudTableComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c1);
            i0.ɵɵelementStart(0, "ui-toolbar")(1, "div", 2);
            i0.ɵɵprojection(2);
            i0.ɵɵconditionalCreate(3, CrudTableComponent_Conditional_3_Template, 6, 3, "ui-input-group", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵconditionalCreate(4, CrudTableComponent_Conditional_4_Template, 2, 2, "div", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "ui-card");
            i0.ɵɵconditionalCreate(6, CrudTableComponent_Conditional_6_Template, 4, 0, "p", 5);
            i0.ɵɵpipe(7, "async");
            i0.ɵɵconditionalCreate(8, CrudTableComponent_Conditional_8_Template, 2, 3, null, 6);
            i0.ɵɵpipe(9, "async");
            i0.ɵɵconditionalBranchCreate(10, CrudTableComponent_Conditional_10_Template, 1, 1, "ui-loading-indicator", 7);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(11, "ui-menu", 8, 0);
            i0.ɵɵpipe(13, "async");
          }
          if (rf & 2) {
            let tmp_4_0;
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(!ctx.header ? 3 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional((ctx.config.list.filters == null ? null : ctx.config.list.filters.length) > 0 ? 4 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(i0.ɵɵpipeBind1(7, 6, ctx.hasActiveFilters$) ? 6 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional((tmp_4_0 = i0.ɵɵpipeBind1(9, 8, ctx.tableState$)) ? 8 : 10, tmp_4_0);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("popup", true)("model", i0.ɵɵpipeBind1(13, 10, ctx.contextMenuActionsForItem$));
          }
        },
        dependencies: [UiToolbarComponent, UiInputGroupComponent, UiButtonComponent, NgClass, CustomAttributesDirective, DynamicFieldsetModule, i5.FilterFieldsetComponent, i6.UiCardComponent, i6.UiTemplateDirective, NgLetDirective, i7.UiTableComponent, i7.UiTableSortIcon, i7.SortableColumn, i7.SelectableRow, i7.ReorderableRow, i7.ContextMenuRow, UiIconComponent, NgStyle, CrudTableItemComponent, UiLoadingIndicatorComponent, UiMenuComponent, AsyncPipe],
        styles: ["[_nghost-%COMP%]{display:flex;flex-direction:column;height:initial}[_nghost-%COMP%] > ui-card[_ngcontent-%COMP%]{flex:1;overflow:auto}filter-fieldset.has-active-filters[_ngcontent-%COMP%]     ui-input-group{outline:2px solid var(--contrastColor)}.active-filters-notification[_ngcontent-%COMP%]{background:var(--softGreyColor);padding:5px;text-align:center;font-weight:700;width:300px;margin:10px auto 20px;border-radius:18px;position:relative}.active-filters-notification[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{position:absolute;right:3px;top:2px}[_nghost-%COMP%]     .p-datatable table{table-layout:auto!important}[_nghost-%COMP%]     .p-datatable table th{position:sticky;top:0;z-index:99}"],
        changeDetection: 0
      });
    }
  }
  return CrudTableComponent;
})();